
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.show
      },
      set(value) {
        this.$emit('update:show', value)
      }
    }
  },
  data() {
    return {
      selectedItems: [],
      textarea: '',
      // 目前约定的数据是定死的，后续会根据用户反馈进行修改
      arrList: [
        {
          name: '67639',
          type: 1
        },
        {
          name: '67640',
          type: 2
        },
        {
          name: '67641',
          type: 4
        },
        {
          name: '67642',
          type: 8
        },
        {
          name: '67643',
          type: 16
        },
        {
          name: '67644',
          type: 32
        }
      ]
    }
  },
  methods: {
    open() {
      // 触发事件通知父组件打开对话框
      this.$emit('update:show', true)
    },
    toggleSelection(item) {
      const index = this.selectedItems.findIndex(selected => selected.content === item.content)
      if (index > -1) {
        // 如果已选中，则移除
        this.selectedItems.splice(index, 1)
      } else {
        // 如果未选中，则添加
        this.selectedItems.push(item)
      }
    },
    handleClose() {
      // 关闭对话框，会自动触发emit事件
      this.$emit('handleClose')
      this.selectedItems = []
      this.textarea = ''
      this.dialogVisible = false
    },
    handleSubmit() {
      // 提交表单数据
      if (this.selectedItems.length === 0) {
        return
      }
      
      // 计算多个选中项的type值（使用按位或操作合并）
      const totalType = this.selectedItems.reduce((sum, item) => sum | item.type, 0)
      const typeNames = this.selectedItems.map(item => this.$t(item.name)).join(', ')
      
      const submitData = {
        type: totalType,
        typeName: typeNames,
        textarea: this.textarea,
        selectedTypes: this.selectedItems.map(item => ({
          type: item.type,
          typeName: this.$t(item.name)
        }))
      }
      
      // 可以在这里处理表单验证和数据提交逻辑
      console.log('提交数据', submitData)
      
      // 提交成功后可以关闭对话框
      this.dialogVisible = false
      
      // 触发提交成功事件通知父组件
      this.$emit('submit-success', submitData)
      
      // 重置表单
      this.selectedItems = []
      this.textarea = ''
    }
  }
}
